import {
    getOptionsForFeature,
    OwsOptionsFeatureType,
    ConfettiOptions,
} from 'owa-outlook-service-options';
import isConfettiEnabled from '../selectors/isConfettiEnabled';

export default function isConfettiOptionDirty(): boolean {
    let userOptions = getOptionsForFeature<ConfettiOptions>(OwsOptionsFeatureType.Confetti);
    return isConfettiEnabled() !== userOptions.confettiEnabled;
}
